import apiClient from './apiClient';

// Trade Plans API
export const tradePlansApi = {
  // List user's trade plans
  listTradePlans: async (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.category) {
      params.append('category', filters.category);
    }
    if (filters.isActive !== undefined) {
      params.append('isActive', filters.isActive);
    }
    if (filters.limit) {
      params.append('limit', filters.limit);
    }
    if (filters.offset) {
      params.append('offset', filters.offset);
    }
    
    const response = await apiClient.get(`/trade-plans?${params.toString()}`);
    return response.data;
  },

  // Get specific trade plan
  getTradePlan: async (planId) => {
    const response = await apiClient.get(`/trade-plans/${planId}`);
    return response.data;
  },

  // Create new trade plan
  createTradePlan: async (planData) => {
    const response = await apiClient.post('/trade-plans', planData);
    return response.data;
  },

  // Update trade plan
  updateTradePlan: async (planId, updates) => {
    const response = await apiClient.put(`/trade-plans/${planId}`, updates);
    return response.data;
  },

  // Delete trade plan
  deleteTradePlan: async (planId) => {
    const response = await apiClient.delete(`/trade-plans/${planId}`);
    return response.data;
  },

  // Duplicate plan
  duplicatePlan: async (planId, newName) => {
    const response = await apiClient.post(`/trade-plans/${planId}/duplicate`, { name: newName });
    return response.data;
  }
};

export default tradePlansApi;
